import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SnackService} from '../../services/snack.service';
import {Customer} from '../../model/Entities/Customer';
import {CustomerService} from '../../services/customer.service';
import {PaymentType} from '../../model/Entities/PaymentType';
import {FormControl, Validators} from '@angular/forms';
import {numberValidator} from '../../validators/number.validator';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {AresService} from '../../services/ares.service';
import {AresResponse} from '../../model/Entities/AresResponse';


@Component({
    selector: 'customer-edit',
    templateUrl: './customer-edit.component.html',
    styleUrls: ['./customer-edit.component.scss']
})
export class CustomerEditComponent implements OnInit {
    customer: Customer = new Customer();
    paymentTypeEnum: any = PaymentType;
    editing = false;

    nameFC = new FormControl('', [
        Validators.required,
    ]);

    // secondNameFC = new FormControl('', [
    // ]);

    invoiceNameFC = new FormControl('', [
        Validators.required,
    ]);

    invoiceStreetFC = new FormControl('', [
        // Validators.required,
    ]);

    invoiceCityFC = new FormControl('', [
        // Validators.required,
    ]);

    invoiceZipFC = new FormControl('', [
        // Validators.required,
    ]);

    companyNumberFC = new FormControl('', [
        Validators.required,
    ]);

    emailFC = new FormControl('', [
        Validators.required,
        Validators.email,
    ]);

    phoneFC = new FormControl('', [
        Validators.required,
    ]);

    saleFC = new FormControl('', [
        Validators.required,
        Validators.min(0),
        Validators.max(100),
        numberValidator()
    ]);

    lossSaleFC = new FormControl(false, [Validators.required]);
    addresses: any[] = [];
    addressSearchValue = '';

    constructor(private route: ActivatedRoute,
                private router: Router,
                private customerService: CustomerService,
                // private paymentTypeService: PaymentTypeService,
                private snackService: SnackService,
                private http: HttpClient,
                private cdr: ChangeDetectorRef,
                private aresService: AresService) {
    }

    ngOnInit(): void {
        // this.paymentTypeService.getPaginatedList().subscribe((types: PaymentType[]) => {
        //     this.paymentTypes = types;
        //
        //     if (!this.editing) {
        //         this.customer.paymentTypeId = this.paymentTypes[0].id;
        //     }
        // });

        const id = +this.route.snapshot.paramMap.get('id');
        if (id !== 0) {
            this.editing = true;
            this.loadCustomer(id);
        } else {
        }
    }

    save(): void {
        if (this.editing) {
            this.customerService.update(this.customer.id, this.customer).subscribe(() => {
                this.router.navigate([`/customer/${this.customer.id}`]);
                this.snackService.showSuccess(`Objednatel ${this.customer.name} byl upraven`);
            });
        } else {
            this.customerService.save(this.customer).subscribe((customer: Customer) => {
                this.router.navigate([`/customer/${customer.id}`]);
                this.snackService.showSuccess(`Objednatel ${this.customer.name} byl vytvořen`);
            });
        }
    }

    checkValidity(): boolean {
        return this.nameFC.valid
            && this.customer.address && this.customer.addressLat && this.customer.addressLon
            // && this.secondNameFC.valid
            && this.invoiceNameFC.valid
            && this.invoiceStreetFC.valid
            && this.invoiceCityFC.valid
            && this.invoiceZipFC.valid
            && (!this.customer.enterprise || this.companyNumberFC.valid)
            // && this.emailFC.valid
            // && this.phoneFC.valid
            && this.saleFC.valid;
    }

    nameChange(): void {
        if (this.customer.invoiceName === '') {
            this.customer.invoiceName = this.customer.name;
        }
    }

    onCompanyNumberChange(): void {
        const ico = this.customer.invoiceCompanyNumber;
        if (ico && ico.length === 8) {
            this.loadFromAres(ico);
        }
    }

    loadFromAres(ico: string): void {
        this.aresService.getByIco(ico).subscribe(
            (data: AresResponse) => {
                this.customer.name = data.name;
                this.customer.invoiceName = data.invoiceName;
                this.customer.invoiceVatNumber = data.invoiceVatNumber;
                this.customer.invoiceVatPayer = data.invoiceVatPayer;

                if (data.invoiceStreet && data.invoiceCity) {
                    const address = `${data.invoiceStreet}, ${data.invoiceCity}, ${data.invoiceZip}`;
                    this.addressSearchValue = address;
                    this.loadAddresses(address, true);
                }

                this.snackService.showSuccess('Data z ARES byla načtena');
                this.cdr.detectChanges();
            }
        );
    }


    searchAddress($event: KeyboardEvent) {
        const search = $event.target['value'];
        this.loadAddresses(search);
    }

    loadAddresses(search: string, autoSelect: boolean = false) {
        if (!search || search.length < 3) {
            this.addresses = [];
            return;
        }

        const apiKey = environment.apiMapyCom;
        const url = `https://api.mapy.com/v1/suggest?query=${encodeURIComponent(search)}&type=regional.address,poi&apiKey=${apiKey}`;

        this.http.get<any>(url).subscribe(
            (response) => {
                this.addresses = response.items || [];
                if (autoSelect && this.addresses.length === 1) {
                    this.selectAddress(this.addresses[0]);
                }
            },
            (error) => {
                console.error("Nepodařilo se načíst adresy:", error);
                this.addresses = [];
            }
        );
    }

    selectAddress(address) {
        this.customer.invoiceCity = '';
        this.customer.invoiceZip = '';
        this.customer.invoiceStreet = '';
        let hasMunicipalityPart = address.regionalStructure.some(s => s.type === 'regional.municipality_part');
        address.regionalStructure.forEach(structure => {
            if (structure.type === 'regional.municipality_part') {
                if (this.customer.invoiceCity !== '') {
                    this.customer.invoiceCity = structure.name + ' - ' + this.customer.invoiceCity;
                } else {
                    this.customer.invoiceCity = structure.name;
                }
            }
            if (structure.type === 'regional.municipality' && !hasMunicipalityPart) {
                this.customer.invoiceCity = structure.name;
            }
            if (structure.type === 'regional.street' || structure.type === 'regional.address') {
                this.customer.invoiceStreet = structure.name + ' ' + this.customer.invoiceStreet;
            }
        });
        this.customer.invoiceZip = address.zip;
        this.customer.address = address.name + ', ' + address.zip + ', ' + address.location;
        this.customer.addressLat = address.position.lat;
        this.customer.addressLon = address.position.lon;
    }



    private loadCustomer(id: Number): void {
        this.customerService.get(id).subscribe((customer: Customer) => {
            this.customer = customer;
            this.lossSaleFC.setValue(this.customer.lossSale);
            this.cdr.detectChanges();
        });
    }
}



// WEBPACK FOOTER //
// /app/src/CustomersModule/CustomerEditComponent/customer-edit.component.ts